import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas } from '../../../../../helpers';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';
import { trackingEvent } from '../../../../../helpers/tracking';

const tracking = {
    eventAction: 'Prosperity Planner - Step 5',
    eventLabel: 'Asses My Finances - What I Have'
};

export const formName = Routes.STEPFIVE;

export const formDetails = {
    key: 'current',
    title: 'What I have',
    formName,
    totalKey: 'currentTotal',
    fields: {
        savings: {
            label: 'Savings'
        },
        investments: {
            label: 'Investments',
            tooltip: 'Excluding mortgage payments and auto loans'
        },
        assets: {
            label: 'Major Assets'
        }
    }
};

const minValue = 0;

const validate = values => v(values,
    Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: {
            numericality: {
                greaterThanOrEqualTo: minValue,
                notGreaterThanOrEqualTo: `must be greater than or equal to $${numberWithCommas(minValue)}`
            }
        }
    }), {})
);

class StepFiveForm extends Component {
    calculateTotal() {
        const {
            formValues: {
                [formDetails.totalKey]: removedTotal,
                ...values
            }
        } = this.props;

        return Object.values(values).reduce((total, val) => total + val, 0);
    }

    componentDidUpdate() {
        const {
            props: {
                changeFieldValue
            }
        } = this;

        changeFieldValue(formDetails.totalKey, this.calculateTotal());
    }

    render() {
        const {
            formValues : {
                [formDetails.totalKey]: total
            } = {}
        } = this.props;
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key => (
                        <Field
                            key={key}
                            type='text'
                            name={key}
                            label={formDetails.fields[key].label}
                            tooltip={formDetails.fields[key].tooltip}
                            prefix='$'
                            format={numberWithCommas}
                            parse={parseNumberWithCommas}
                            component={RenderInput}
                        />
                    ))
                }
                <Field
                    type='text'
                    name='total'
                    label='Total'
                    prefix='$'
                    readOnlyValue={numberWithCommas(total)}
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                />
            </form>
        );
    }
}

const formValues = getFormValues(formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formName, field, value))
});

StepFiveForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    skipPath: `/prosperity-planner${Routes.SUMMARY}`,
    redirectPath: `/prosperity-planner${Routes.STEPSIX}`,
    tracking: () => trackingEvent(tracking)
}, mapStateToProps, mapDispatchToProps)(StepFiveForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepFiveForm));
